// Angular
import { Component, Input } from '@angular/core';
import { OnInit, OnDestroy, AfterContentInit } from '@angular/core';
import { ElementRef } from '@angular/core';

@Component({
  selector: 'app-preloader',
  templateUrl: './preloader.component.html',
  styles: []
})
export class PreloaderComponent implements OnInit, OnDestroy, AfterContentInit {
  @Input() public fullscreen = false;

  public parentWidth: number = null;
  public parentHeight: number = null;

  constructor(
    private el: ElementRef,
  ) {
    console.log('PreloaderComponent: Constructor');
  }

  ngAfterContentInit() {
    this.parentWidth = this.el.nativeElement.parentElement.clientWidth;
    this.parentHeight = this.el.nativeElement.parentElement.clientHeight;
  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

}
